import { useMantineTheme, Badge, BadgeProps, MantineTheme } from "@mantine/core";

import { getSizeTrust } from "utils/utils";

import { packSx } from "./mantine-extended";

function getSampleSizeCategorization(sampleSize: number, theme: MantineTheme) {
  const sampleSizeData = [
    { label: "Insufficient", colors: theme.colors.proposal },
    { label: "Small", colors: theme.colors.approval },
    { label: "Medium", colors: [theme.colors.blue[0], theme.colors.blue[1], theme.colors.blue[7]] },
    { label: "Large", colors: theme.colors.finalized },
    { label: "Very Large", colors: theme.colors.finalized },
  ];

  return sampleSizeData[getSizeTrust(sampleSize)];
}

interface SampleSizeBadgeProps extends BadgeProps {
  sampleSize: number;
  withSuffix?: boolean;
}

export function SampleSizeBadge({
  sampleSize,
  withSuffix = false,
  sx,
  ...rest
}: SampleSizeBadgeProps) {
  const theme = useMantineTheme();

  const { label, colors } = getSampleSizeCategorization(sampleSize, theme);

  return (
    <Badge
      variant="light"
      sx={[
        {
          textTransform: "none",
          border: `1px solid ${colors[1]}`,
          backgroundColor: colors[1],
          color: colors[2],
        },
        ...packSx(sx),
      ]}
      {...rest}
    >
      {label}
      {withSuffix ? " Sample Size" : ""}
    </Badge>
  );
}
